const navItems = [
    {
      key: "dashboard",
      label: "Dashboard",    
      path: "/"
    },
    {
      key: "video",
      label: "Studio",    
      path: "/studio"
    },
    // {
    //   key: "video_flight",
    //   label: "Video Flights",
    //   
    //   path: "/video/flights"
    // },
    {
      key: "campaigns",
      label: "Campaign",    
      path: "/campaign"
    },
    {
      key: "publishers",
      label: "Publisher",    
      path: "/publisher"
    },
    // {
    //   key: "iab",
    //   label: "IAB Categories",    
    //   path: "/iab"
    // },
    {
      key: "demand_partners",
      label: "Demand Partner",    
      path: "/demand_partners"
    },
    // {
    //   key: "vastEditor",
    //   label: "VAST Editor",    
    //   path: "/vast/editor"
    // },
    {
      key: "report",
      label: "Reporting",
      path: "/report"
    },
    // {
    //   key: "blacklist",
    //   label: 'Adomain Black-list',
    //   path: '/blacklist',
    // },
    // {
    //   key: "iab-blacklist",
    //   label: 'IAB Black-List',
    //   path: '/iab-blacklist',
    // },

    // {
    //   key: "bid_template",
    //   label: 'Bid Sample',
    //   path: '/bid-template',
    // },

  ];
  
  const lastNavItem = undefined;
  
  export {navItems,lastNavItem}